export function printHtml(html) {
  return new Promise((resolve) => {
    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = '0'

    document.body.appendChild(iframe)

    const win = iframe.contentWindow
    const doc = win.document

    doc.open()
    doc.write(html)
    doc.close()

    let cleaned = false
    const cleanup = () => {
      if (cleaned) return
      cleaned = true
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
      resolve()
    }

    const pendingImages = Array.from(doc.images).filter((img) => !img.complete)
    const waitImages = pendingImages.map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve
          img.onerror = resolve
        })
    )

    Promise.all(waitImages).then(() => {
      win.onafterprint = cleanup
      setTimeout(cleanup, 60000)
      win.focus()
      win.print()
    })
  })
}
